<div id="igenapps-menu-tab" class="tab-list" >
	<slot></slot>
</div>

<style>
	.tab-list {
	display: flex;
	align-items:center;
	align-content: center;
	justify-content:space-evenly;
	width:100%;	
	background-color: var(--user-color);
	position: absolute; 
	bottom: 0;
	height: 75px;
		/* border-bottom: 1px solid teal;*/
	} 
</style>